module.exports = __webpack_public_path__ + "img/schnittkante_blau_candy.7a141739.jpg";